import React, { Component } from 'react';

import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Api } from '../../utils/api';

export class AdminView extends Component {

  state = {
    admin: null
  };

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidUpdate(prevProps){
    const { adminId } = this.props;

    if (prevProps.adminId === adminId) return;

    if (!adminId) {
      this.setState({ admin: null });
      return;
    }

    this.api.get(`/admins/${adminId}`, {}, true)
      .then(({data: admin}) => this.setState({admin}));
  }

  componentDidMount() {
    const {adminId} = this.props;
    if (!adminId) return;

    this.api.get(`/admins/${adminId}`, {}, true)
      .then(({data: admin}) => this.setState({admin}));
  }

  render() {
    let {label, image, column} = this.props;
    if (label) {
      label = label.slice(0, 2);
    }

    return (
      this.state.admin ? (
        <Grid item>
        <Grid container alignItems="center" direction={column?"column":"inherit"}>
          {image && (
            <Avatar
              className='image-avatar'
              src={`https://www.laresonline.pt${this.state.admin.image}`}
            />
          )}
          {!image && label && (
            <Avatar className={`${label.toLowerCase()}-avatar`}> {label}
            </Avatar>
          )}
          <Typography color="inherit" variant="body2">
            {this.state.admin ? this.state.admin.name : '-'}
          </Typography>
        </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="center"></Grid>
      )
    );
  }

}
